import { ref } from 'vue'
import { FEED_CONSTANTS, NAVIGATION_DIRECTION } from '@/Shared/feedConstants'

/**
 * Composable for handling mouse wheel navigation with debouncing
 * Prevents multiple posts from being swiped during momentum scrolling
 *
 * @param {Function} navigateToPost - Navigation handler function
 * @param {Ref} scrollLocked - Reference to scroll lock state
 * @returns {Object} Wheel navigation handler
 */
export function useWheelNavigation(navigateToPost, scrollLocked) {
    const isWheelNavigating = ref(false)
    let wheelTimeout = null

    const handleWheel = (event) => {
        event.preventDefault()

        if (scrollLocked.value) {
            return
        }

        if (wheelTimeout) {
            clearTimeout(wheelTimeout)
        }

        if (isWheelNavigating.value) {
            wheelTimeout = setTimeout(() => {
                isWheelNavigating.value = false
                wheelTimeout = null
            }, FEED_CONSTANTS.WHEEL_DEBOUNCE_MS)
            return
        }

        isWheelNavigating.value = true
        const direction = event.deltaY > 0 ? NAVIGATION_DIRECTION.NEXT : NAVIGATION_DIRECTION.PREV
        navigateToPost(direction)

        wheelTimeout = setTimeout(() => {
            isWheelNavigating.value = false
            wheelTimeout = null
        }, FEED_CONSTANTS.WHEEL_DEBOUNCE_MS)
    }

    return {
        handleWheel,
        isWheelNavigating,
    }
}
